module.exports = __webpack_public_path__ + "static/img/img_7.1ae4daa8.jpg";